import _ from 'lodash';
import { MessageDescriptor } from 'react-intl';
import { CoreAcquisitionConstants } from 'app/interfaces/Image';
import { MAX_KV, MIN_KV, MIN_MA, getKVLimits } from 'app/utils/acquisitionConstants';

function computeMaxSeconds(mAsLimit: number, mA: number): number {
  // mAs = mA * s
  // s = mAs / mA
  return _.round(mAsLimit / mA, 3);
}

export default function validateAcquisitionConstants(constants: CoreAcquisitionConstants) {
  const { kV, mA, s } = constants;
  const errors: Partial<
    Record<keyof CoreAcquisitionConstants, MessageDescriptor & { values?: Record<string, string> }>
  > = {};

  if (kV < MIN_KV || kV > MAX_KV) {
    errors.kV = { id: 'kVRange', values: { min: MIN_KV.toString(), max: MAX_KV.toString() } };
  }
  const kvLimits = getKVLimits(kV);
  const mAsLimits = kvLimits.mAsLimits[mA as keyof typeof kvLimits.mAsLimits];

  if (mA < MIN_MA || mA > kvLimits.mA || !mAsLimits) {
    errors.mA = { id: 'mARange', values: { min: MIN_MA.toString(), max: kvLimits.mA.toString() } };
  }
  if (!mAsLimits) {
    if (s <= 0.003) {
      errors.s = { id: 'sRange', values: { min: '0.003', max: '1.6' } };
    }
  } else {
    const maxSeconds = computeMaxSeconds(mAsLimits, mA);
    if (s <= 0.003 || s > maxSeconds) {
      errors.s = { id: 'sRange', values: { min: '0.003', max: maxSeconds.toString() } };
    }
  }

  if (Object.keys(errors).length > 0) {
    return errors;
  }

  return undefined;
}
